import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { getSipTransactionDetails } from '../../../../redux-store/actions/commercialTransactions';
import en from '../../../../lang/en-us';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { SipTransactionObjectType, SipTransactionPropsType } from './types';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { decimalFix } from '../../portfolios/utils';
import { formatAsIndianCurrency } from '../../../../utils/currency';

const { dbCommercial } = en;

const columns: TableColumn[] = [
    {
        field: 'instalmentNumber',
        headerName: 'Installment Number',
        width: 150,
    },
    {
        field: 'nav',
        headerName: 'Nav',
        valueGetter: ({ row }: any) =>
            decimalFix(row.nav) ? formatAsIndianCurrency(decimalFix(row.nav)) : 'N/A',
        width: 150,
    },
    {
        field: 'units',
        headerName: 'Units',
        valueGetter: ({ row }: any) => decimalFix(row.units) || 'N/A',
        width: 150,
    },
    {
        field: 'instalmentAmount',
        headerName: 'Installment Amount',
        valueGetter: ({ row }: any) => formatAsIndianCurrency(row.instalmentAmount) || 'N/A',
        width: 150,
    },
    {
        field: 'instalmentDate',
        headerName: 'Installment Date',
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 150,
    },
];

export default function SipTransactionDetails({ payload, amcCode }: SipTransactionPropsType) {
    const [rowData, setRowData] = useState<Array<SipTransactionObjectType>>([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const {
                    body: { data = [] },
                }: any = await dispatch(
                    getSipTransactionDetails({ amc: amcCode, data: [payload] }),
                );
                setRowData(data);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
    }, []);

    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<Array<SipTransactionObjectType>>({
        initialSelectionModal: [],
        rows: rowData,
        columns,
        loading,
    });

    return (
        <div className="curved-bg-content curved-bg-table-outer">
            <div className="curved-bg-content-table">
                <>
                    <h5> {dbCommercial.sipTransaction.heading}</h5>
                    {!!loading || tableRows.length ? (
                        <TableWithCollapse
                            rows={tableRows}
                            columns={tableColumns}
                            isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                            toolTipEnabled
                            resetFilters={resetFilters}
                            {...filters}
                        />
                    ) : (
                        <NoFoliosFound info={'No Transactions Found'} />
                    )}
                </>
            </div>
        </div>
    );
}
